// Alocação de Pessoal (Gestão Orçamentária): grade mensal de % de alocação dos colaboradores
// da OPERAÇÃO em projetos. Espelha backend/config.py ROLES_ALOCACAO_PESSOAL — mantenha os dois
// em sincronia. onlyFormulario (Formulário GP) entra só nesta tela — nenhuma outra da Gestão
// Orçamentária (nem o Boas-vindas · Custos, que usa ROLES_BOAS_VINDAS_CUSTOS).
export const ROLES_ALOCACAO_PESSOAL = ["admin", "EXECUTIVA", "GESTOR_ESTRATEGICO", "OPERACAO", "ASSISTENTEOPERACAO", "onlyFormulario"];
export const ROLES_BOAS_VINDAS_CUSTOS = ROLES_ALOCACAO_PESSOAL.filter((r) => r !== "onlyFormulario");
